import { Base } from './Base';

export abstract class V1 extends Base
{
	protected _ddsObj=null;
	protected _pubKey=null;
	protected _pubAuth=null;

	//if no value was specified, this is the value we will be looking for, cant use null since thats a real value to be set
	protected _anyUpChange="fa5a12c41ee7cb0deadef153c14f678e233f5b72970b183dba8af8d0bbb7727d";
	protected _pubUpWaits={};
	
	protected _pubDelWaitId=null;
	protected _pubDelWait=null;

	protected _getPubThrowAfterTerm=false;
	protected _pubStore=null;
	protected _subCbs=[];
	
	public setConfig(ddsObj, pubKey, pubAuth)
	{
		this._ddsObj		= ddsObj;
		this._pubKey		= pubKey;
		this._pubAuth		= pubAuth;
		return this;
	}
	protected pubKey()
	{
		return this._pubKey;
	}
	protected pubAuth()
	{
		return this._pubAuth
	}
	protected ddsClient()
	{
		return this._ddsObj;
	}
	protected async pubStore()
	{
		if (this._pubStore === null) {
			this._pubStore	= await this.ddsClient().getPublicStore(this.pubKey(), this.pubAuth());
			this._pubStore.addUpdateCb(this, "pubUpdateCb").addDeleteCb(this, "pubDeleteCb");
		}
		return this._pubStore;
	}
	protected getPubKey(key, throwOnErr=false)
	{
		if (this.isTerm() === false) {
			if (this._pubStore !== null) {
				return this._pubStore.getKey(key, throwOnErr);
			} else if (throwOnErr === true) {
				throw this.getMtm().newException("Key: " + key + ", does not exist");
			} else {
				return null;
			}
			
		} else if (throwOnErr === true) {
			throw this.getMtm().newException("Cannot get key: "+key+" after termination");
		} else {
			return null;
		}
	}
	protected async getTrackHash(input)
	{
		return await this.getMtm().get("utilities").getHashing().getSHA().get256(JSON.stringify(input));
	}
	public async pubUpdateCb(storeObj)
	{
		var eAttrs	= Object.keys(this._pubUpWaits);
		if (eAttrs.length > 0) {

			var dObj	= storeObj.getData();
			var cAttrs	= Object.keys(dObj);
			for (let cAttr of cAttrs) {
				var nameHash		= await this.getTrackHash(cAttr);
				if (typeof this._pubUpWaits[nameHash] !== "undefined") {
					var attrObj	= this._pubUpWaits[nameHash];
					var valHash	= await this.getTrackHash(dObj[cAttr]);
					if (typeof attrObj[valHash] !== "undefined") {
						var valObj		= attrObj[valHash];
						var eTimeouts	= Object.keys(valObj);
						for (let eTimeout of eTimeouts) {
							var toObj	= valObj[eTimeout];
							delete valObj[eTimeout];
							try {
								toObj["resolve"](this);
							} catch (errObj) {
								//control yourself
							}
						}
						if (Object.keys(valObj).length < 1) {
							delete attrObj[valHash];
						}
					}
					if (Object.keys(attrObj).length < 1) {
						delete this._pubUpWaits[nameHash];
					}
				}
			}
			
			if (typeof this._pubUpWaits[this._anyUpChange] !== "undefined") {
				var attrObj	= this._pubUpWaits[this._anyUpChange];
				delete this._pubUpWaits[this._anyUpChange];
				var eVals	= Object.keys(attrObj);
				for (let eVal of eVals) {
					var valObj		= attrObj[eVal];
					var eTimeouts	= Object.keys(valObj);
					for (let eTimeout of eTimeouts) {
						var toObj	= valObj[eTimeout];
						try {
							toObj["resolve"](this);
						} catch (errObj) {
							//control yourself
						}
					}
				}
			}
		}
		Object.keys(this._subCbs).forEach(index => {
			var cb	= this._subCbs[index];
			try {
				cb[0][cb[1]](this, "update");
			} catch (e) {
				this.pubUnsubscribe(cb[0], cb[1]);
				this.logInfo("Sub threw during update. Disconnected method: "+cb[1]);
			}
		});
		return this;
	}
	public async getPubUpdateWait(attrName=undefined, attrVal=undefined, timeout=10000)
	{
		//if you want to set a value and wait for the update to propagate
		//keep public so extanal classes are allowed to wait for pending changes
		var nameHash	= null;
		if (typeof attrName === "undefined") {
			nameHash	= this._anyUpChange;
		} else {
			nameHash	= await this.getTrackHash(attrName);
		}
		var valHash		= null;
		if (typeof attrVal === "undefined") {
			valHash		= this._anyUpChange;
		} else {
			valHash		= await this.getTrackHash(attrVal);
		}
		var expire		= this.getMtm().get("utilities").getTime().getMicroEpoch();
		if (timeout > 0) {
			expire	+= (timeout / 1000);
		} else {
			throw this.getMtm().newException("Timeout must be greater than 0")
		}

		var attrObj	= null;
		var eAttrs	= Object.keys(this._pubUpWaits);
		if (typeof this._pubUpWaits[nameHash] === "undefined") {
			attrObj						= {};
			this._pubUpWaits[nameHash]	= attrObj;
		} else {
			attrObj		= this._pubUpWaits[nameHash];
		}
		var valObj	= null;
		if (typeof attrObj[valHash] === "undefined") {
			valObj				= {};
			attrObj[valHash]	= valObj;
		} else {
			valObj				= attrObj[valHash];
		}
		var toObj	= null;
		if (typeof valObj[expire] === "undefined") {
			toObj			= this.getMtm().newPromise();
			valObj[expire]	= toObj;

			setTimeout(()=> {
				if (
					typeof this._pubUpWaits[nameHash] !== "undefined"
					&& typeof this._pubUpWaits[nameHash][valHash] !== "undefined"
					&& typeof this._pubUpWaits[nameHash][valHash][expire] !== "undefined"
				) {
					var promObj	= this._pubUpWaits[nameHash][valHash][expire];
					if (Object.keys(this._pubUpWaits[nameHash][valHash]).length > 1) {
						delete this._pubUpWaits[nameHash][valHash][expire];
					} else {
						delete this._pubUpWaits[nameHash][valHash];
					}
					if (Object.keys(this._pubUpWaits[nameHash]).length < 1) {
						delete this._pubUpWaits[nameHash];
					}
					promObj["reject"](this.getMtm().newException("Timeout waiting for update confirmation"));
				}
			}, timeout);
			
		} else {
			toObj	= valObj[expire];
		}
		return toObj.promise;
	}
	public async pubUpdateClear(promise)
	{
		try {
			await promise;
		} catch (errObj) {
			//do nothing, we cannot cancel a promise
			//so if a set function fails for whatever reason
			//while holding a wait promise, the wait promise will cause
			//an uncaught exception, unless the set dumps the promise here
			console.log("dumping rejected promise");
			console.log(errObj);
		}
	}
	public getPubDeleteWait()
	{
		//if you want to set a value and wait for the delete to propagate
		//keep public so extanal classes are allowed to wait for pending changes
		if (this._pubDelWait === null) {
			var waitId			= this.getMtm().get("utilities").getGuids().getV4().get(false);
			this._pubDelWaitId	= waitId;
			this._pubDelWait	= this.getMtm().newPromise();
			setTimeout(()=> {
				if (waitId === this._pubDelWaitId) {
					//timeout the wait if it goes on too long
					var promObj			= this._pubDelWait;
					this._pubDelWaitId	= null;
					this._pubDelWait	= null;
					promObj["reject"](this.getMtm().newException("Timeout waiting for delete confirmation"));
				}
			}, 10000);
		}
		return this._pubDelWait.promise;
	}
	public pubDeleteCb(storeObj)
	{
		this.pubDeleteClear();
		
		Object.keys(this._subCbs).forEach(index => {
			var cb	= this._subCbs[index];
			try {
				cb[0][cb[1]](this, "delete");
				this.pubUnsubscribe(cb[0], cb[1]);
			} catch (e) {
				this.pubUnsubscribe(cb[0], cb[1]);
			}
		});
		
		this.terminate();
	}
	public pubDeleteClear()
	{
		if (this._pubDelWait !== null) {
			var promObj			= this._pubDelWait;
			this._pubDelWaitId	= null;
			this._pubDelWait	= null;
			promObj["resolve"](this);
		}
		return this;
	}
	public async pubSubscribe(cbObj, cbMethod)
	{
		var exists		= false;
		Object.keys(this._subCbs).forEach(index => {
			var cb		= this._subCbs[index];
			if (cb[0] === cbObj && cb[1] === cbMethod) {
				exists	= true;
			}
		});
		if (exists === false) {
			this._subCbs.push([cbObj, cbMethod]);
		}
		return this;
	}
	public async pubUnsubscribe(cbObj, cbMethod)
	{
		Object.keys(this._subCbs).forEach(index => {
			var cb		= this._subCbs[index];
			if (cb[0] === cbObj && cb[1] === cbMethod) {
				delete this._subCbs[index];
			}
		});
		return this;
	}
	public terminate(throwOnErr=false)
	{
		//place holder overide in child class
		this.setTerm();
	}
}